/* global angular, moment */

/**
 * Created by lari on 07/06/2017.
 */
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcutils.doctor.factory:Doctor
   *
   * @description
   *
   */
  angular
    .module('vcutils.doctor')
    .factory('Doctor', Doctor);
  
  Doctor.$inject = ['restmod'];
  function Doctor(restmod) {
    return restmod.model('/routes/doctors', 'PagedModel').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/doctors/docahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          } // $searchahead
        } // Model
      }// extend
    });
  }

  // klammerfriedhof
}());
